import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorReportingService } from './error-reporting.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // Lazy via Injector to avoid circular deps during app bootstrap
  private errorReporter?: ErrorReportingService;

  constructor(private readonly injector: Injector) {}

  handleError(error: unknown): void {
    console.error('[GlobalErrorHandler]', error);

    try {
      if (!this.errorReporter) {
        this.errorReporter = this.injector.get(ErrorReportingService);
      }
      const err = error instanceof Error ? error : new Error(String(error));
      this.errorReporter.report({
        message: err.message || String(error),
        error_type: err.name || (error as any)?.constructor?.name || 'UnknownError',
        severity: 'error',
        stack_trace: err.stack,
      });
    } catch {
      // Never let error reporting break the app
    }
  }
}
